<script>
export default {
  props: {
    data: { type: Array, required: true },
    height: { type: Number, required: true },
    width: { type: Number, required: true },
    ttHeight: { type: Number, default: 20 },
    ttWidth: { type: Number, default: 180 },
    xProp: { type: String, default: 'dt' },
    yProp: { type: String, required: true }
  },

  functional: true,

  render(h, { props, listeners }) {
    const { width, height, xProp, yProp, data } = props

    const { fillPathD, strokePathD, xScale, points } = computeAll({
      width,
      height,
      xProp,
      yProp,
      rows: data
    })

    const fillPath = `
      <path
        shape-rendering="auto"
        fill="aliceblue"
        stroke="none"
        d="${fillPathD}"
      />`

    const strokePath = `
      <path
        shape-rendering="auto"
        stroke="steelblue"
        stroke-width="1.5"
        fill="none"
        d="${strokePathD}"
      />`

    const onMouseOver = (evt) => {
      const fn = listeners && listeners.highlight
      if (!fn) return null

      const mouseX = evt.clientX - evt.target.getBoundingClientRect().x
      if (mouseX < 0) return null

      const mouseDate = xScale.invert(mouseX)

      // eslint-disable-next-line no-undef
      const bisectDate = d3.bisector((d) => d[0]).left
      const idx = bisectDate(points, mouseDate)

      fn(data[idx])
    }

    const onMouseLeave = (/*evt*/) => {
      const fn = listeners && listeners.highlight
      if (fn) fn(null)
    }

    const result = h('div', {
      style: { width: '100%' },
      on: {
        mousemove: onMouseOver,
        mouseleave: onMouseLeave
      },
      domProps: {
        innerHTML: `
        <svg
          class="bar-chart"
          width="100%"
          height="${props.height}"
          shape-rendering="crispEdges"
        >
          ${fillPath}
          ${strokePath}
        </svg>
      `
      }
    })

    return result
  }
}

function computeAll({ width, height, xProp, yProp, rows }) {
  const points = rows.map((row) => {
    return [row[xProp], row[yProp]]
  })

  // eslint-disable-next-line no-undef
  const xExtent = d3.extent(points, (d) => d[0])
  // eslint-disable-next-line no-undef
  // o minY sempre será 0
  // eslint-disable-next-line no-undef
  const yExtent = [0, d3.max(points, (d) => d[1])]

  // eslint-disable-next-line no-undef
  const xScale = d3.scale
    .linear()
    .domain(xExtent)
    .range([0, width])

  // eslint-disable-next-line no-undef
  const yScale = d3.scale
    .linear()
    .domain(yExtent)
    .range([height, 0])

  // eslint-disable-next-line no-undef
  const lineFunc = d3.svg
    .line()
    .x((d) => xScale(d[0]))
    .y((d) => yScale(d[1]))

  const fillPathD = computeFillPath({
    points,
    xExtent,
    yExtent,
    lineFunc
  })

  const strokePathD = computeStrokePath({
    points,
    lineFunc
  })

  return { fillPathD, strokePathD, xScale, yScale, points }
}

function computeFillPath({ points, xExtent, yExtent, lineFunc }) {
  let clone = points.slice() // shallow clone

  // primeiro ponto extra: [maxX, minY]
  let z0 = [xExtent[1], yExtent[0]]

  // segundo ponto extra: [minX, minY]
  let z1 = [xExtent[0], yExtent[0]]

  clone.push(z0, z1)
  return lineFunc(clone)
}

function computeStrokePath({ points, lineFunc }) {
  return lineFunc(points)
}
</script>

<style>
.lineChartTooltip {
  font-size: 12px;
  line-height: 14px;
  background-color: rgba(255, 255, 255, 0.8);
  text-align: left;
}

.lineChartTooltip.left {
  text-align: right;
}
</style>
